/**
 * Converts polar coordinates to cartesian coordinates.
 *
 * @param cx - The x-coordinate of the circle's center.
 * @param cy - The y-coordinate of the circle's center.
 * @param radius - The radius of the circle.
 * @param angleInDegrees - The angle in degrees.
 * @returns An object containing the x and y coordinates.
 */
export const polarToCartesian = (cx: number, cy: number, radius: number, angleInDegrees: number) => {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;
  return {
    x: cx + radius * Math.cos(angleInRadians),
    y: cy + radius * Math.sin(angleInRadians)
  };
};
